import { format, formatDistanceToNow, Locale } from 'date-fns';
import { enCA, frCA } from 'date-fns/locale';

import { Locales } from '@/store/language.interface';
import { getLocale } from '@/utils/data-display-utils';

function diffInDays(start: number | string | Date, end: number | string | Date): number {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const diffInMilliseconds = endDate.valueOf() - startDate.valueOf();
  const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);
  return Math.round(diffInDays);
}

function formatDate(date: number, languageEnabled: Locales[] | undefined = []): string {
  let dateFormat: string;
  let locale: Locale;
  switch (getLocale(languageEnabled)) {
    case 'en':
      dateFormat = 'yyyy MMMM d';
      locale = enCA;
      break;
    case 'fr':
    default:
      dateFormat = 'd MMMM yyyy';
      locale = frCA;
      break;
  }
  return format(new Date(date * 1000), dateFormat, { locale });
}

function formatDistanceDateToNow(date: Date, languageEnabled: Locales[] | undefined = []): string {
  const locale = (() => {
    switch (getLocale(languageEnabled)) {
      case 'en':
        return enCA;
      case 'fr':
      default:
        return frCA;
    }
  })();
  return formatDistanceToNow(date, { locale });
}

function getCurrentYear(): number {
  return new Date().getFullYear();
}

function todayInTimestamp(): number {
  return Math.floor(Date.now() / 1000);
}

export { diffInDays, formatDate, formatDistanceDateToNow, getCurrentYear, todayInTimestamp };
